import { render, staticRenderFns } from "./EventStatusChipCancelled.vue?vue&type=template&id=90360ea6&scoped=true&"
import script from "./EventStatusChipCancelled.vue?vue&type=script&lang=js&"
export * from "./EventStatusChipCancelled.vue?vue&type=script&lang=js&"
import style0 from "./EventStatusChipCancelled.vue?vue&type=style&index=0&id=90360ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90360ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
